import React, { useState, useRef, useEffect } from 'react';

const WhatsAppChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const messagesEndRef = useRef(null);

  const faqResponses = {
    'precio': 'Nuestros planes comienzan desde $299/mes. ¿Te gustaría conocer más detalles sobre nuestros planes?',
    'servicios': 'Ofrecemos Marketing Digital, Desarrollo Web y Social Media. ¿Cuál de estos servicios te interesa más?',
    'tiempo': 'Los resultados varían según el plan, pero generalmente se ven en 2-3 meses.',
    'contacto': 'Puedes contactarnos por WhatsApp, email o a través del formulario de contacto.',
    'default': 'Gracias por tu mensaje. Un asesor te contactará pronto. ¿Hay algo más en lo que pueda ayudarte?'
  };

  const faqButtons = [
    { label: '¿Cuánto cuesta?', key: 'precio' },
    { label: '¿Qué servicios ofrecen?', key: 'servicios' },
    { label: '¿Cuánto tiempo para ver resultados?', key: 'tiempo' },
    { label: '¿Cómo los contacto?', key: 'contacto' }
  ];

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleUserMessage = (msg) => {
    const lowerMsg = msg.toLowerCase();
    let response = faqResponses.default;

    for (const key in faqResponses) {
      if (lowerMsg.includes(key)) {
        response = faqResponses[key];
        break;
      }
    }

    setMessages(prev => [
      ...prev,
      { text: msg, sender: 'user', timestamp: new Date().toLocaleTimeString() },
      { text: response, sender: 'bot', timestamp: new Date().toLocaleTimeString() }
    ]);
  };

  const handleSendMessage = () => {
    if (inputMessage.trim() === '') return;
    handleUserMessage(inputMessage);
    setInputMessage('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSendMessage();
  };

  const handleFAQClick = (key) => {
    const label = faqButtons.find(f => f.key === key)?.label || key;
    handleUserMessage(label);
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end">
      {isOpen && (
        <div className="bg-white rounded-lg shadow-xl p-4 mb-4 w-80 flex flex-col">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-lg font-semibold text-gray-800">Chat con Bitnea</h3>
            <button onClick={() => setIsOpen(false)} className="text-gray-500 hover:text-gray-700">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="flex flex-col space-y-2 mb-3">
          {faqButtons.map(btn => (
  <button
    key={btn.key}
    onClick={() => handleFAQClick(btn.key)}
    className="text-left px-4 py-2 bg-gray-100 text-gray-800 rounded-lg hover:bg-blue-400 hover:text-white transition-colors text-sm"
  >
    {btn.label}
  </button>
))}
          </div>

          <div className="h-80 overflow-y-auto mb-3">
            <div className="bg-gray-100 rounded-lg p-3 mb-2">
              <p className="text-sm text-gray-800">¡Hola! 👋 ¿En qué podemos ayudarte hoy?</p>
            </div>
            {messages.map((message, index) => (
              <div
  key={index}
  className={`mb-2 p-3 rounded-lg text-sm ${
    message.sender === 'user'
      ? 'bg-blue-400 text-white ml-12'
      : 'bg-gray-100 text-gray-800 mr-12'
  }`}
>
                {message.text}
                <div className="text-xs text-right opacity-60 mt-1">{message.timestamp}</div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>

          <div className="flex">
            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Escribe tu mensaje..."
              className="flex-1 border rounded-l-lg px-4 py-2 focus:outline-none focus:border-blue-400"
            />
            <button
              onClick={handleSendMessage}
              className="bg-blue-400 text-white px-4 py-2 rounded-r-lg hover:bg-blue-500"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
              </svg>
            </button>
          </div>
        </div>
      )}

      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-green-500 text-white rounded-full p-4 shadow-lg hover:bg-green-600 transition-colors"
      >
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
        </svg>
      </button>
    </div>
  );
};

export default WhatsAppChat;
